import { useContext, useEffect, useState } from "react";
import { ImporterQuote } from "../../store/types";
import { PButtonPure, PSpinner, PText } from "@porsche-design-system/components-react";
import { CustomTableHeader } from "../../components/customTable/customTableHeader";
import { CustomTable } from "../../components/customTable/customTable";
import TextField from "../../components/textField/textField";
import { RequestHeader } from "../../api/RequestHeader";
import UserContext, {UserContextType} from "../../store/UserContext";
import { useModelState } from "../../store/ModelContext";
import {
	getImportersQuoteByOrderTypeAndQuoteYear,
} from "../../api/ModelImporterQuoteService";
import { Grid } from "@react-css/grid";
import { Flex } from "@react-css/flex";

const ApiUrl = process.env.REACT_APP_BACKEND_URL;

function QuotaTab(props : any) {
	const { lenaAuthToken } = useContext<UserContextType>(UserContext);
	const modelContextState = useModelState();
	const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
	const [importerQuotes, setImporterQuotes] = useState<ImporterQuote[]>([]);
	const [loading, setLoading] = useState(false);
	const tableId = "quotaTable";

	useEffect(() => {
		if (modelContextState.globalOrderType === "") {
			setImporterQuotes([]);
		} else {
			setLoading(true);
			getImportersQuoteByOrderTypeAndQuoteYear(lenaAuthToken, modelContextState.globalOrderType, selectedYear)
				.then((response) => {
						response.forEach((iq) => {
							if (iq.quote === undefined) {
								iq.quote = null;
							}
						});
						setImporterQuotes(response);
						setLoading(false);
				})
				.catch((error) => console.log(error.message));
		}
	}, [modelContextState.globalOrderType, selectedYear, lenaAuthToken, props.triggerUpdate]);

	function saveModelWithImporterAndQuote(importerQuote: ImporterQuote){
		fetch(ApiUrl + "/saveModelWithImporterAndQuote", {
			method: "POST",
			headers: RequestHeader.createPutHeader(lenaAuthToken),
			body: JSON.stringify(importerQuote)
		}).then(async (response) => {
			if (!response.ok) {
				throw new Error(await response.text());
			}
		});
	}

	function handleImporterQuote(currentImporterNr: string, newQuote: string) {
		let newImporterQuotes = [...importerQuotes];
		let quoteField = document.getElementById("quote-for-" + currentImporterNr);

		const reg = new RegExp("^[0-9]+$");
		if (newQuote === "" || (reg.test(newQuote) && parseInt(newQuote) >= 0)) {
			let currentImporterQuote = newImporterQuotes.find((q) => q.importer === currentImporterNr);
			currentImporterQuote.quote = newQuote;
			currentImporterQuote.imported = false;
			setImporterQuotes(newImporterQuotes);
			quoteField.style.borderColor = "#c8cacb";
			saveModelWithImporterAndQuote(currentImporterQuote);
		} else {
			quoteField.style.borderColor = "red";
		}
	}


	return (
		<div className="wrapper">
				<Grid autoFlowColumn={true} columns='[first] 20% [line2] 80%' style={{marginBottom:"30px"}}>
					<Grid.Item >
						<PText className={"quota-tab-year-change"} autoFocus={false} size={"small"} inert={true}> Fiscal year</PText>
					</Grid.Item>
					<Grid.Item >
						<Flex>
							<PButtonPure
								autoFocus={false} hideLabel={true}
								icon={"arrow-head-left"}
								size={"small"}
								onClick={() => {
									setSelectedYear(selectedYear - 1);
								}}
								inert={false}
							/>
							<PText className={"quota-tab-year"} autoFocus={false} size={"small"} inert={true}>
								{selectedYear}
							</PText>
							<PButtonPure
								hideLabel={true} autoFocus={false}
								icon={"arrow-head-right"}
								size={"small"}
								onClick={() => {
									setSelectedYear(selectedYear + 1);
								}}
								inert={false}
							/>
						</Flex>
					</Grid.Item>
				</Grid>

			{loading && <PSpinner className={"spinner"} autoFocus={false} size={{ base: "small", l: "medium" }} inert={true} /> }
			{!loading && Array.from(importerQuotes).length > 0 && (
				<CustomTable tableId={tableId} width={"800px"}>
					<thead>
						<tr>
							<CustomTableHeader text={"Partner No."} tableId={tableId} columnPos={0} sortable={true} />
							<CustomTableHeader text={"Importer"} tableId={tableId} columnPos={1} sortable={true} />
							<CustomTableHeader text={selectedYear} tableId={tableId} columnPos={2} sortable={true} width={"50px"} />
						</tr>
					</thead>
					<tbody>
						{Array.from(importerQuotes).map((importer) => {
							return (
								<tr key={importer.importer}>
									<td>{importer.importer}</td>
									<td>{importer.importerDescription}</td>
									<td style={{ width: "100px" }}>
										<TextField
											id={"quote-for-" + importer.importer}
											placeholder={""}
											onChange={(value) => handleImporterQuote(importer.importer, value)}
											isError={false}
											value={importer.quote === null ? "" : importer.quote}
											className={"quoteTab-quote"}
											disabled={importer.imported}
										/>
									</td>
								</tr>
							);
						})}
					</tbody>
				</CustomTable>
			)}
		</div>
	);
}
export default QuotaTab;
